import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';
import { Star } from 'lucide-react';

const RATING = '4,9';
const REVIEW_COUNT = '1272';
const GOOGLE_URL = 'https://maps.app.goo.gl/Sccu3gjHYFVVPJ8V9';

const GoogleG = ({ className }) => (
  <svg className={className} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
    <path d="M43.611 20.083H42V20H24v8h11.303c-1.649 4.657-6.08 8-11.303 8-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 12.955 4 4 12.955 4 24s8.955 20 20 20 20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z" fill="#FFC107"/>
    <path d="M6.306 14.691l6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 16.318 4 9.656 8.337 6.306 14.691z" fill="#FF3D00"/>
    <path d="M24 44c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238A11.91 11.91 0 0124 36c-5.202 0-9.619-3.317-11.283-7.946l-6.522 5.025C9.505 39.556 16.227 44 24 44z" fill="#4CAF50"/>
    <path d="M43.611 20.083H42V20H24v8h11.303a12.04 12.04 0 01-4.087 5.571l.003-.002 6.19 5.238C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917z" fill="#1976D2"/>
  </svg>
);

const GoogleRatingBadge = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <a
      href={GOOGLE_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="google-rating-badge"
      className="fixed z-[60] rating-pulse bg-white text-gray-900 rounded-2xl px-2.5 py-2 md:px-3 md:py-3 flex flex-col items-center gap-0.5 md:gap-1 shadow-2xl transition-transform duration-300 hover:scale-105 w-[64px] md:w-[86px] left-2 bottom-4 top-auto translate-y-0 md:left-3 md:top-1/2 md:bottom-auto md:-translate-y-1/2"
    >
      <GoogleG className="w-5 h-5 md:w-6 md:h-6" />
      <span className="text-lg md:text-2xl font-extrabold leading-none">{RATING}</span>
      <div className="flex gap-0.5" aria-hidden>
        {[0, 1, 2, 3, 4].map((i) => (
          <Star key={i} className="w-2.5 h-2.5 md:w-3 md:h-3 fill-[#FFC107] text-[#FFC107]" />
        ))}
      </div>
      <span className="text-[9px] md:text-[10px] font-semibold text-gray-600 text-center leading-tight">
        {REVIEW_COUNT} {t.rating_reviews_label}
      </span>
    </a>
  );
};

export default GoogleRatingBadge;
